
import React, { useState } from 'react'
import styled from 'styled-components'
import { colors } from '../../Assets/styles/colors'
import { ReactComponent as RightArrow } from "../../Assets/icons/dropDownArrow.svg";
import LanguageListSelector from './LanguageListSelector';
import { getFlag } from '../../Helpers/FlagHandler';
import { useTranslate } from '@tolgee/react';
import { ReactComponent as MicIcon } from "../../Assets/iconsv2/settings/microphone.svg";

const LanguageBtn = ({ value, setValue, placeholder, placeholderIcon, valuesList, callLanguage }) => {
    const { t } = useTranslate();

    let foundValue = valuesList.find(item => item.name === value)

    if (callLanguage) {
        foundValue = valuesList.find(item => item.locale === value)
    }

    const [isLanguagelistOpen, setIsLanguageListOpen] = useState(false);

    const openLanguageList = () => {
        setIsLanguageListOpen(!isLanguagelistOpen)
    }

    return (
        <Container>
            {isLanguagelistOpen &&
                <LanguageListSelector
                    isLanguageSelectorOpen={isLanguagelistOpen}
                    setValue={setValue}
                    valuesList={valuesList}
                    openLanguageList={openLanguageList}
                    callLanguage={callLanguage}
                />
            }
            <ButtonContainer
                value={value}
                onClick={openLanguageList}>
                {value && foundValue ? (
                    <>
                        <Flag src={getFlag(foundValue.country_code)} alt={foundValue.name} />
                        <ValueName>{`${foundValue.name} (${foundValue.translation})`}</ValueName>
                        {foundValue.voice_cloning_supported && (
                            <VoiceCloneBadge title={t("video_tool.voice_cloning_supported_tooltip")}>
                                <MicIcon />
                            </VoiceCloneBadge>
                        )}
                        <RightArrow style={{ marginLeft: foundValue.voice_cloning_supported ? "8px" : "auto", width: "14px" }} />
                    </>
                )
                    : (
                        <>
                            {placeholderIcon}
                            <ValueName disabled>{placeholder}</ValueName>
                            <RightArrow style={{ marginLeft: "auto", width: "14px" }} />
                        </>
                    )
                }


            </ButtonContainer>

        </Container>


    )
}

export default LanguageBtn

const Container = styled.div`

`
const ButtonContainer = styled.div`
display:flex;
align-items:center;
gap:10px;
padding:16px;
border-radius: 4px;
background:${({ theme }) => theme.menu.groupContentBackground};
cursor:pointer;
svg{
color:${({ theme }) => theme.menu.primaryTextColor};
opacity:${({ value }) => value ? "1" : "0.6"};
}
`
const ValueName = styled.h3`
  font-size: 16px;
  font-weight: 400;
  line-height: 22px;
  text-align: left;
 color:${({ theme }) => theme.menu.primaryTextColor};
${props => props.disabled && (`opacity:0.6;`)}
`


const Flag = styled.img`
     width:20px;
     height:20px;
     display:flex;
     object-fit:contain;
     `

const VoiceCloneBadge = styled.span`
     margin-left:auto;
     display:flex;
     align-items:center;
     opacity:0.7;
     flex-shrink:0;
     svg{
     width:16px;
     height:16px;
     }
     `